import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowDown, ArrowRight } from "lucide-react";

export const Hero = () => (
    <section
        data-testid="hero-section"
        className="relative h-[100svh] min-h-[640px] w-full overflow-hidden"
    >
        <div className="absolute inset-0 overflow-hidden">
            <img
                src="/images/hero.jpg"
                alt="Bâtiment équestre et chevaux au coeur d'un haras"
                className="h-full w-full object-cover rz-hero-zoom"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-rz-deep/55 via-rz-deep/45 to-rz-deep/85" />
            <div className="absolute inset-0 bg-rz-deep/15" />
        </div>

        <div className="relative z-10 mx-auto flex h-full max-w-[1400px] flex-col justify-end px-6 md:px-12 pb-20 md:pb-28">
            <motion.span
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, delay: 0.2 }}
                className="text-xs md:text-sm tracking-[0.25em] uppercase text-white/80 mb-5"
            >
                ROZIER CONCEPT — Agricole &amp; Haras
            </motion.span>

            <motion.h1
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.9, delay: 0.35, ease: [0.16, 1, 0.3, 1] }}
                className="font-display text-white font-extrabold tracking-tighter leading-[0.95] text-[clamp(2.6rem,7vw,6rem)] max-w-5xl [text-shadow:_0_2px_30px_rgba(10,26,18,0.45)]"
            >
                Bâtiments agricoles <br className="hidden md:block" />
                <span className="text-rz-pale [text-shadow:_0_2px_24px_rgba(10,26,18,0.7)]">&amp; équestres</span> sur mesure
            </motion.h1>

            <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.55 }}
                className="mt-6 max-w-xl text-base md:text-lg text-white/85 leading-relaxed"
            >
                100% adaptés à votre activité. Allier performance agricole, bien-être animal
                et construction durable pour bâtir les exploitations de demain.
            </motion.p>

            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.7 }}
                className="mt-9 flex flex-wrap items-center gap-4"
            >
                <Link
                    to="/contact"
                    data-testid="hero-contact-cta"
                    className="group inline-flex items-center gap-2 rounded-full bg-white px-7 py-3.5 text-sm font-semibold text-rz-green transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl hover:shadow-black/25"
                >
                    Démarrer votre projet
                    <ArrowRight
                        size={17}
                        className="transition-transform duration-300 group-hover:translate-x-1"
                    />
                </Link>
                <a
                    href="#qui-sommes-nous"
                    data-testid="hero-scroll-cta"
                    className="inline-flex items-center gap-2 rounded-full border border-white/30 px-7 py-3.5 text-sm font-semibold text-white transition-colors duration-300 hover:bg-white/10"
                >
                    Qui sommes-nous
                </a>
            </motion.div>
        </div>

        <div className="absolute bottom-8 right-6 md:right-12 z-10 hidden md:flex items-center gap-2 text-white/60 text-xs tracking-widest uppercase">
            <ArrowDown size={14} className="animate-bounce" /> Défiler
        </div>
    </section>
);
